// extracted by mini-css-extract-plugin
export default {"surveyBar":"index_surveyBar_MSAVb","head":"index_head_hJcp0","logo":"index_logo_qPk4g","more":"index_more_2rVGU","title":"index_title_ooYaI"};